import { render, staticRenderFns } from "./disable.vue?vue&type=template&id=46dce6cb&"
import script from "./disable.vue?vue&type=script&lang=ts&"
export * from "./disable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports